import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import AuthRoutes from "@/modules/Auth/route";
import FlightRoutes from "./flightRoutes";
import HotelRoutes from "./hotelRoutes";
import TourRoutes from "./tourRoutes";
import HomeRoutes from "./homeRoutes";

import { PATH } from "@/core/constants/path";
import {
  AuthMiddleware,
  CheckPermissionsMiddleware,
  CheckRoleMiddleware,
  ScrollToTopMiddleware,
} from "./middleware";
import { setupChunkLoadRecovery } from "@/core/utils/chunkLoadRecovery";

const routes: Array<RouteRecordRaw> = [
  {
    path: PATH.ROOT,
    name: "auth",
    meta: {
      isProtected: false,
    },
    children: AuthRoutes,
  },
  {
    path: PATH.ROOT,
    name: "homeRoutes",
    component: () => import("@/core/Layout/HomeLayout.vue"),
    meta: {
      isProtected: true,
    },
    children: HomeRoutes,
  },
  {
    path: PATH.HOTELS,
    name: "hotelRoutes",
    component: () => import("@/core/Layout/HomeLayout.vue"),
    meta: {
      isProtected: true,
    },
    children: HotelRoutes,
  },
  {
    path: PATH.FLIGHTS,
    name: "flightRoutes",
    component: () => import("@/core/Layout/HomeLayout.vue"),
    meta: {
      isProtected: true,
    },
    children: FlightRoutes,
  },
  {
    path: PATH.FIX_DEPARTURE_GROUP,
    name: "tourRoutes",
    component: () => import("@/core/Layout/HomeLayout.vue"),
    meta: {
      isProtected: true,
    },
    children: TourRoutes,
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(AuthMiddleware);
router.beforeEach(CheckRoleMiddleware);
router.beforeEach(CheckPermissionsMiddleware);
router.beforeEach(ScrollToTopMiddleware);

setupChunkLoadRecovery(router);

export default router;
